var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaurus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#D78888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3676 4.18179C12.3099 4.18179 11.4489 5.04281 11.4489 6.10044C11.4489 6.10609 11.4489 6.11174 11.4489 6.11626V6.12869C11.4455 6.91513 10.8037 7.55468 10.0162 7.55468C9.22858 7.55468 8.5879 6.91626 8.58338 6.12869V6.11626C8.58338 6.11626 8.58338 6.10496 8.58338 6.10044C8.58338 5.04281 7.72236 4.18179 6.66474 4.18179C5.60711 4.18179 4.74609 5.04281 4.74609 6.10044C4.74609 6.4236 5.00824 6.68462 5.33027 6.68462C5.65231 6.68462 5.91445 6.42247 5.91445 6.10044C5.91445 5.68688 6.25118 5.35129 6.66361 5.35129C7.07604 5.35129 7.40937 5.68349 7.41276 6.09366V6.10609C7.41276 6.10609 7.41276 6.11739 7.41276 6.12191C7.41276 6.85185 7.71445 7.51174 8.20033 7.98405C6.84101 8.6575 5.90316 10.0609 5.90316 11.6778C5.90316 13.9502 7.75174 15.7987 10.0241 15.7987C12.2964 15.7987 14.145 13.9502 14.145 11.6778C14.145 10.0552 13.2026 8.64959 11.8354 7.97727C12.3167 7.50496 12.6162 6.84733 12.6162 6.12078C12.6162 6.11513 12.6162 6.10948 12.6162 6.10496V6.09253C12.6195 5.68236 12.954 5.35016 13.3653 5.35016C13.7766 5.35016 14.1145 5.68688 14.1145 6.09931C14.1145 6.42247 14.3766 6.68349 14.6986 6.68349C15.0207 6.68349 15.2828 6.42134 15.2828 6.09931C15.2828 5.04168 14.4218 4.18066 13.3642 4.18066L13.3676 4.18179ZM12.9777 11.6778C12.9777 13.3061 11.6534 14.6293 10.0252 14.6293C8.39694 14.6293 7.07378 13.305 7.07378 11.6778C7.07378 10.0507 8.39807 8.72643 10.0252 8.72643C11.6523 8.72643 12.9777 10.0507 12.9777 11.6778Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurus);
export default __webpack_public_path__ + "static/media/taurus.442ec61136197c3025035198017de712.svg";
export { ForwardRef as ReactComponent };